import { RsValue } from '../models/base/BaseModel';
import api from './axios';

export interface INotification {
  id: string;
  title: string;
  message: string;
  createdAt: string;
  isRead: boolean;
}

export const notificationService = {
  getNotifications: (): Promise<RsValue<INotification[] | null>> =>
    api.get('api/Notification'),

  markAsRead: (id: string): Promise<RsValue<boolean>> =>
    api.post(`api/Notification/${id}/read`),
};
